module.exports = __webpack_public_path__ + "static/img/cj.082a8ac7.png";